import React from "react";
import {
    BusinessPortalHeader, PortalPageShell, LottieLoadingIndicator,
} from "src/components";

import { FormBackground } from "../../components/Utils";

const LoadingForm = (props) => {
    return (
        <PortalPageShell>
            <BusinessPortalHeader
                title="Edit Poll"
                description="Easily set up a new poll to gather quick feedback or opinions. Customise your poll question, add answer options, and share it directly with your team or clients through the Me Business app. Get real-time results to make informed decisions."
                maxWidth="37.5rem"
            />
            <FormBackground style={{ height: "35rem" }}>
                <LottieLoadingIndicator />
            </FormBackground>
        </PortalPageShell>
    );
};

export default LoadingForm;
